import React, { useState } from 'react';
import { ToggleButton, ToggleButtonGroup, Box, Grid } from '@mui/material';
import LineChartComponent from '../LineChartComponent/LineChartComponent';
import ReturnExperienceChart from '../ReturnExperienceChart';

const ChartSelection = ({ data, metric }) => {
  const [selectedType, setSelectedType] = useState('Active');
  const [selectedView, setSelectedView] = useState('Cumulative');

  const handleTypeChange = (event, newType) => {
    if (newType !== null) {
      setSelectedType(newType);
    }
  };

  const handleViewChange = (event, nextView) => {
    if (nextView !== null) {
      setSelectedView(nextView);
    }
  };

  const getChartData = () => {
    const payload = data?.[selectedType]?.[0]?.[metric];
    if (!payload || !Array.isArray(payload.datasets)) {
      return { title: 'No Data', labels: [], datasets: [] };
    }
    return payload;
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <ToggleButtonGroup
            value={selectedType}
            exclusive
            onChange={handleTypeChange}
            aria-label="Chart Type"
          >
            <ToggleButton value="Absolute" aria-label="Absolute">
              Absolute
            </ToggleButton>
            <ToggleButton value="Active" aria-label="Active">
              Active
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>

        <Grid item>
          <ToggleButtonGroup
            value={selectedView}
            exclusive
            onChange={handleViewChange}
            aria-label="Cone chart view"
          >
            <ToggleButton value={'Cumulative'} aria-label="Cumulative">
              Cumulative
            </ToggleButton>
            <ToggleButton value={'5 Year Simulations'} aria-label="5 Year Simulations">
              5 Year Simulations
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>

      <Box width="100%" mt={2}>
        {selectedView === 'Cumulative' ? (
          <LineChartComponent chartData={getChartData()} />
        ) : (
          <ReturnExperienceChart
            data={data}
            selectedType={selectedType}
            onTypeChange={setSelectedType}
            showTypeToggle={false}
          />
        )}
      </Box>
    </Box>
  );
};

export default ChartSelection;
